(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-audio"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-audio"] = factory(root["mggp-player"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__239__) => {
return 